module.exports = __webpack_public_path__ + "static/media/nina-icon.d5efcda6.png";